import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { chatbot } from 'src/assets/chatbot.js';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.scss']
})
export class ContactusComponent implements OnInit {
  img: any;
  isMobileView: any;

  constructor(
    private csObj: CommonService
  ) {

  }

  currentUser: any;
  ngOnInit(): void {
    this.currentUser = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.currentUser);

    if(this.currentUser?.userDetails?.userType === 2){
      chatbot();
    }
    this.img = "../../../../../assets/contact/lap.png";
    this.checkScreenSize();
    window.addEventListener('resize', () => {
      this.checkScreenSize();
    });

  }

  checkScreenSize() {
    this.isMobileView = window.innerWidth < 440;
  }

}
